import React, { useCallback, useState } from 'react'
import { Button, Card, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import queryString from 'query-string'
import { useNavigate } from 'react-router-dom'

import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import useAxios from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'
import { IProductGroup } from '../../../../types/product-group'
import PageUrls from '../../../../constants/page-urls'
import { ProductGroupFormModal } from '../../components/ProductGroupFormModal'
import ProductGroupsTable from '../../components/ProductGroupsTable'
import ProductGroupFilter, {
  IFilterMapped,
} from '../../components/ProductGroupFilter'

const Menus = [
  {
    breadcrumbName: 'รายการสินค้า',
    title: 'รายการสินค้า',
    path: PageUrls.Product,
  },
  {
    breadcrumbName: 'หมวดหมู่สินค้า',
    title: 'หมวดหมู่สินค้า',
    path: PageUrls.Category,
  },
]

const ProductGroupsListPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [isModalCreate, setIsModalCreate] = useState<boolean>(false)
  const initialFilter: IFilterMapped = {
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length ? String(queryStr.search) : undefined,
  }
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>(initialFilter)
  const [filter, setFilter] = useState<IFilterMapped>(initialFilter)

  const applyFilter = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    navigate(`${PageUrls.ProductGroup}?${queryString.stringify(newFilter)}`, {
      replace: true,
    })
  }

  const handleSearch = (newFilter: IFilterMapped) => {
    applyFilter({ ...newFilter, page: 1 })
  }

  const productGroupList = useAxios<PaginationResponseInterface<IProductGroup>>(
    {
      method: 'GET',
      url: '/product-group',
      params: searchFilter,
    },
  )

  const onSaveSuccess = useCallback(async () => {
    await productGroupList.mutate()
  }, [productGroupList])

  return (
    <ContentWrapper>
      <Helmet title="กลุ่มสินค้า" />
      <ProductGroupFormModal
        isOpen={isModalCreate}
        onClose={(visible: boolean) => setIsModalCreate(visible)}
        onSaveSuccess={onSaveSuccess}
      />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="กลุ่มสินค้า"
            routes={Menus}
            descriptions="จัดกลุ่มสินค้าไว้ใช้กรองคำสั่งซื้อ"
            tags={[
              {
                title: 'จำนวน',
                color: 'info',
                value: productGroupList.data?.count ?? 0,
                classifier: 'กลุ่ม',
              },
            ]}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            onClick={() => setIsModalCreate(true)}
          >
            กลุ่มสินค้า
          </Button>
        </Grid>
      </Grid>
      <Card sx={{ padding: 2 }}>
        <ProductGroupFilter
          filter={filter}
          onFilterChange={setFilter}
          onSearch={handleSearch}
        />
        <ProductGroupsTable
          isLoading={productGroupList.isLoading}
          data={productGroupList.data?.records ?? []}
          filter={searchFilter}
          onUpdateSuccess={onSaveSuccess}
          handlePageChange={(page) =>
            applyFilter({
              ...searchFilter,
              page: page.page,
              perPage: page.perPage,
            })
          }
          total={productGroupList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default ProductGroupsListPage
